import { lazy, Suspense } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';
import { getBuyerId } from 'dibs-cookie-jar';

const FooterSubscribeReactLazy = lazy(() =>
    import(/* webpackChunkName: "FooterSubscribe" */ './FooterSubscribe')
);

let isInitiallyLoggedIn;

const FooterSubscribeLazy = props => {
    const isClient = useClientState();

    if (!isClient) {
        return null;
    }

    // This has to be below client check, as needs access to document
    // Check only once, as we need to keep FooterSubscribe rendered after user subscribes
    isInitiallyLoggedIn =
        isInitiallyLoggedIn === undefined ? !!getBuyerId(document.cookie) : isInitiallyLoggedIn;
    if (isInitiallyLoggedIn) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <FooterSubscribeReactLazy {...props} />
        </Suspense>
    );
};

export default FooterSubscribeLazy;
